<template>
    <div>
        <div>
            <div class="w3-container flow-main-content w3-center w3-padding w3-ripple">
                <p class="w3-col w3-center">
                    <input class="w3-input w3-border w3-round-medium w3-padding-large"
                           type="text"
                           v-bind:placeholder="$t('searchPhysiciansPlaceholder')"
                           v-model="searchKey">
                </p>
            </div>

            <div class="w3-container flow-card blue-top w3-animate-opacity flow-main-content">
                <loading v-bind:dspin="!contentLoaded"></loading>
                <table class="w3-table w3-bordered flow-table patients-table" v-show="contentLoaded">
                    <thead class="flow-blue-color">
                        <th>{{ $t("name") }}</th>
                        <th>{{ $t("agendaSystemIds") }}</th>
                        <th>{{ $t("rooms") }}</th>
                        <th>{{ $t("changeStatus") }}</th>
                        <th></th>
                    </thead>
                    <tbody>
                       <tr v-show="getFilteredPhysicians.length === 0">
                        <td colspan="8" class="w3-center flow-blue-color">
                            <b class="font-size-1pt25em">{{$t("noPhysicians")}}</b>
                        </td>
                    </tr>
                    </tbody>

                    <tbody>
                        <template v-for="physician in getFilteredPhysicians">
                            <tr class="no-hover w3-border-0" v-bind:id="physician.id">
                                <td>
                                    <input class="w3-input w3-border w3-round-medium" type="text" v-bind:placeholder="$t('name')" v-model="physician.name"/>
                                    <span class="w3-text-red">{{ physician.nameError }}</span>
                                </td>

                                <td>
                                    <span v-if="isAdmin">
                                        <input class="w3-input w3-border w3-round-medium" type="text"
                                               v-bind:placeholder="$t('agenda')"
                                               v-model="physician.agsId"/>
                                        <span class="w3-text-red">{{ physician.agsError }}</span>
                                    </span>
                                    <span v-else>
                                        {{ physician.agsId }}
                                    </span>
                                </td>

                                <td>
                                    <span v-if="physician.rooms.length === 0">{{$t("noRoomsLinked")}}</span>
                                    <span v-else v-for="room in physician.rooms"
                                          class="consultation-room flow-btn w3-round-medium font-weight-bold cursor-pointer w3-margin-right"
                                          @click="goToRoom(room.id)">
                                    {{room.displayName}}
                                </span>
                                </td>

                                <td>
                                    <button v-if="togglingDoctorID !== physician.id" class="flow-btn cursor-pointer w3-round w3-border w3-ripple w3-round-medium flow-padding-top"  @click="togglePhysicianStatus(physician)">
                                        <i class="fa w3-large transform-animation w3-margin-right"
                                           v-bind:class="isPhysicianActive(physician) ? 'fa-stethoscope flow-green-active-color' : 'fa-coffee flow-orange-text'">
                                        </i>

                                        <i class="fa w3-large transform-animation w3-margin-right fa-long-arrow-alt-right flow-blue-color"></i>

                                        <i class="fa w3-large transform-animation"
                                           v-bind:class="!isPhysicianActive(physician) ? 'fa-stethoscope flow-green-active-color' : 'fa-coffee flow-orange-text'"></i>
                                    </button>
                                    <span v-else>
                                    <i class="fa fa-spinner w3-spin w3-xlarge w3-margin-left w3-opacity w3-disabled transform-animation"></i>
                                </span>
                                </td>

                                <td>
                                    <span v-bind:class="showSaveButton(physician) ? 'cursor-pointer' : 'w3-disabled'" @click.prevent="savePhysician(physician)"
                                          class="btn flow-btn w3-padding-small w3-round-medium">
                                        <i class="fa fa-check-circle w3-large flow-green-active-color"></i>
                                        <span class="flow-green-active-color flow-margin-left font-weight-bold w3-large">{{ $t('confirm') }}</span>
                                    </span>

                                    <span>
                                        <span v-if="isAdmin && !hasDependencies(physician)" class="w3-margin-left cursor-pointer btn flow-btn w3-padding-small w3-round-medium"
                                              @click="deletePhysician(physician)">
                                            <i class="fa fa-trash w3-text-deep-orange"></i>
                                            <span class="w3-text-deep-orange flow-margin-left font-weight-bold w3-large">{{ $t('delete') }}</span>
                                        </span>
                                    </span>
                                </td>
                            </tr>

                            <tr class="no-hover w3-border-0">
                                <td colspan="5">
                                    <div v-if="isAdmin && hasDependencies(physician)">
                                        <span class="w3-col w-100pc w3-center font-weight-bold">
                                            <span class="w3-text-deep-orange">
                                                <i class="fa fa-exclamation-triangle"></i>
                                                <span class="w3-large w3-margin w3-text-deep-orange">Deletion might effect the following</span>
                                            </span>
                                        </span>

                                        <div class="w3-center">
                                            <div class="w3-col w3-half w3-center">
                                                <p class="flow-blue-color w3-large flow-blue-color">{{ $t('users') }}</p>
                                                <p v-for="pu in physician.linkedUsers" class="w-100pc w3-margin-top">
                                                    <b>{{ pu.f_name }} {{ pu.l_name }}</b> <user-role :role="pu.role"></user-role>
                                                </p>
                                            </div>
                                            <div class="w3-col w3-half w3-center">
                                                <p class="flow-blue-color w3-large flow-blue-color">{{ $t('appointments') }}</p>
                                                <p v-for="a in physician.activePatientCount" class="w-100pc w3-margin-top">
                                                    <patient-status :status="a.status" class="zero w3-show-inline-block flow-margin-top"></patient-status> x {{ a.count }}
                                                </p>
                                            </div>
                                        </div>

                                        <span class="w3-center w3-col w-100pc w3-margin w3-padding">
                                            <span class="w3-large font-weight-bold flow-blue-color flow-margin-right">{{ $t('delete')}}</span>
                                            <span class="w3-large font-weight-bold w3-text-deep-orange">{{ physician.name }}</span>
                                            <span class="w3-margin-left cursor-pointer btn flow-btn w3-padding-small w3-round-medium"
                                                  @click.prevent="confirmDeletion(physician)">
                                                <i class="fa fa-trash w3-text-deep-orange"></i>
                                                <span class="flow-blue-color flow-margin-left font-weight-bold w3-large">{{ $t('yes') }}</span>
                                            </span>

                                            <span class="w3-margin-left cursor-pointer btn flow-btn w3-padding-small w3-round-medium"
                                                    @click.prevent="cancelDeletion(physician)">
                                                <i class="fa fa-times flow-blue-color"></i>
                                                <span class="flow-blue-color flow-margin-left font-weight-bold w3-large">{{ $t('no') }}</span>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentHeader from "../common/ContentHeader";
    import Loading from "../common/Loading";
    import Vue from 'vue';
    import {EventBus} from "../../main";
    import NewPhysician from "./NewPhysician";
    import UserRole from "../common/UserRole";
    import PatientStatus from "../common/PatientStatus";

    let frc = Vue.prototype.$frc;

    export default {
        name: "PhysiciansList",
        components: {PatientStatus, UserRole, NewPhysician, Loading, ContentHeader},
        props: ['ftitle'],
        data: function() {
            return {
                contentLoaded: false,
                physicians: [],
                filteredPhysicians: [],
                searchKey: undefined,
                togglingDoctorID: undefined,
                nameError: undefined,
                agsError: undefined,
                masterCopy: {}
            }
        },
        mounted() {
            this.getPhysiciansWithRooms();
            EventBus.$on("wardUpdated", this.getPhysiciansWithRooms);
            EventBus.$on("onNewPhysicianAdded", this.getPhysiciansWithRooms);
        },
        beforeDestroy() {
            EventBus.$off("wardUpdated", this.getPhysiciansWithRooms);
            EventBus.$off("onNewPhysicianAdded", this.getPhysiciansWithRooms);
        },
        computed: {
            isAdmin() {
                return Vue.isAdmin(Vue.prototype.$currentUser.user.role);
            },
            getFilteredPhysicians() {
                if (!this.searchKey || !this.searchKey.trim()) {
                    return this.physicians;
                }

                var regex = new RegExp(this.searchKey, 'i');

                return this.physicians.filter(function(phy) {
                    if (phy.name.match(regex)) {
                        return true;
                    }

                    if (phy.agendaSystemIds) {
                        for (var idx in phy.agendaSystemIds) {
                            if (phy.agendaSystemIds[idx].match(regex)) {
                                return true;
                            }
                        }
                    }

                    return false;
                });
            }
        },
        methods: {
            agsId(physician) {
                if (!physician || !physician.agendaSystemIds || physician.agendaSystemIds.length < 1) {
                    return "";
                }

                return physician.agendaSystemIds[0];
            },
            isPhysicianActive(physician) {
                return physician && physician.status === 'Active';
            },
            getPhysiciansWithRooms() {
                var app = this;
                frc.getPhysiciansWithRoomsInWard(Vue.prototype.$currentWard.id).then(function (res) {
                    var physicians = res.data;
                    physicians.forEach(function (p, i) {
                        if (!p || !p.agendaSystemIds || p.agendaSystemIds.length < 1) {
                            p.agsId = undefined;
                        } else {
                            p.agsId = p.agendaSystemIds[0];
                        }
                        p.nameError = undefined;
                        p.agsError = undefined;
                        p.linkedUsers = undefined;
                        p.activePatientCount = undefined;

                        app.masterCopy[p.id] = {
                            name: p.name, agsId: p.agsId, index: i
                        };
                    });

                    Vue.sortByKey(physicians, 'name');
                    app.physicians = physicians;
                    app.contentLoaded = true;
                    app.togglingDoctorID = undefined;
                });
            },
            goToRoom(roomId) {
                var room = "/room/" + roomId;
                this.$router.push(room);
            },
            togglePhysicianStatus(physician) {
                const app = this;
                app.togglingDoctorID = physician.id;

                if (physician.status === 'Active') {
                    frc.pausePhysician(physician.ward.id, physician.id).then(function(res) {
                        app.getPhysiciansWithRooms();
                        Vue.notifySuccess({message: app.$t("consultationPaused", {'physician' : physician.name})});
                    });
                } else {
                    frc.activatePhysician(physician.ward.id, physician.id).then(function(res) {
                        app.getPhysiciansWithRooms();
                        Vue.notifySuccess({message: app.$t("consultationResumed", {'physician' : physician.name})});
                    });
                }
            },
            savePhysician(p) {
                p.nameError = undefined;
                p.agsError = undefined;

                if (!p.name || !p.name.trim()) {
                    p.nameError = "Name cannot be empty!";
                }
                if (!p.agsId || !p.agsId.trim()) {
                    p.agsError = "AGS cannot be empty";
                }

                if (p.nameError || p.agsError) {
                    return;
                }

                var app = this;
                frc.updatePhysician(p.id, p.name, p.agsId).then(function (res) {
                    var response = res.data;
                    var hasError = false;

                    if (response.name && response.name !== true) {
                        hasError = true;
                        if (response.name.restCodes) {
                            p.nameError = app.$t(response.name.restCodes[0]);
                        } else {
                            p.nameError = app.$t("FAILED_TO_UPDATE");
                        }
                    }

                    if (response.agsId && response.agsId !== true) {
                        hasError = true;
                        if (response.agsId.restCodes) {
                            p.agsError = app.$t(response.agsId.restCodes[0]);
                        } else {
                            p.agsError = app.$t("FAILED_TO_UPDATE");
                        }
                    }

                    if (hasError) {
                        return;
                    }

                    Vue.notifySuccess({title: app.$t("successfullyUpdated")});
                    app.getPhysiciansWithRooms();
                });
            },
            showSaveButton(p) {
                if (!p) {
                    return false;
                }
                var mp = this.masterCopy[p.id];
                if (!mp) {
                    return false;
                }

                return mp.name !== p.name || mp.agsId !== p.agsId;
            },
            deletePhysician(p) {
                var linkedUsers = [];

                frc.getUsersLinkedToPhysician(p.id).then(function (res) {
                    var us = res.data;

                    for (var i in us) {
                        let u = us[i];
                        linkedUsers.push({
                            f_name: u.firstName,
                            l_name: u.lastName,
                            role: u.role,
                            email: u.email
                        });
                    }
                    p.linkedUsers = linkedUsers;
                });

                var activePatientCount = {};
                frc.getPatientsForPhysician(Vue.prototype.$currentWard.id, p.id).then(function (res) {
                    var pats = res.data;

                    pats.forEach(function (p) {
                        if (p.status === "LeavingConsultation" || p.status === "LeftConsultation") {
                            return;
                        }

                        if (!activePatientCount[p.status]) {
                            activePatientCount[p.status] = 0;
                        }
                        activePatientCount[p.status] += 1;
                    });

                    p.activePatientCount = [];
                    for (var i in activePatientCount) {
                        p.activePatientCount.push({status: i, count: activePatientCount[i]});
                    }
                });
            },
            hasDependencies(p) {
                return p.linkedUsers !== undefined || p.activePatientCount !== undefined;
            },
            confirmDeletion(p) {
                var app = this;
                frc.deletePhysician(p.id).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t('success')
                    });
                    app.getPhysiciansWithRooms();
                });
            },
            cancelDeletion(p) {
                p.linkedUsers = undefined;
                p.activePatientCount = undefined;
            }

        }
    }

</script>

<style scoped>
    .no-hover:hover {
        background-color: white !important;
    }
</style>